import {
  createCallableRouteInvoker,
  createCallableStreamRouteInvoker,
} from '../../../../../shared/backend/transports/callable';
import { functionsV9 } from '@/firebaseConfig';

export const invokeCallableRoute = createCallableRouteInvoker(functionsV9);
export const invokeCallableStreamRoute =
  createCallableStreamRouteInvoker(functionsV9);
